import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Redirect",
    component: () =>
      import(/* webpackChunkName: "Redirect" */ "@/components/default/redirect.vue")
  },
  {
    path: "/:lang/chat.html",
    name: "Flixchat",
    component: () =>
      import(/* webpackChunkName: "Flixchat" */ "@/components/default/default.vue")
  },
  {
    path: "/:lang/:chatID/:user.html",
    name: "Supportchat",
    component: () =>
      import(/* webpackChunkName: "Supportchat" */ "@/components/userchat/index.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
